// extracted by mini-css-extract-plugin
module.exports = {"floating":"field-label_floating__l_Cf_","label":"field-label_label__qBwDa"};